export default function OurBrand() {
    return(
        <div style={{background: "rgb(32, 32, 48) ", height: document.documentElement.clientHeight}}>

            <div className="ms-5 text-light">
                <div>


                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <h1>This is our brand page.</h1>
                    <br/>
                    <h1>More coming Soon.</h1>
                </div>
            </div>
        </div>
    )
}